import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import global_axios  from '../../funciones_globales/interaccionapi';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { formatearFecha ,formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';


class FormAdmin02 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            permiso: null,
            empresa: null,
            //DatePicker
            fechaCierre: null,

            //checkbox
            normalizarFecha: false,
        }

        //OVERCONTROLS
        this.actualizarCampos = this.actualizarCampos.bind(this);
        this.changeModulo = this.changeModulo.bind(this);
        this.limpiar = this.limpiar.bind(this);

        //ACTION BUTTON
        this.guardarFechaCierre = this.guardarFechaCierre.bind(this);
    }

    //OverControls
    actualizarCampos(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox'? target.checked : target.value;
        this.setState({
          [name]: value
        });

        if(name==='normalizarFecha' && value ===true){
            this.setState({fechaMod: null})
        }        
    }

    changeModulo(value){
        this.setState({modulos_sel: value!==null?value:null})

        if(value!==null){
            if(value.FechaProceso===null){
                console.log("FECHA PRO: ",this.props.fechaProceso)
                this.setState({fechaOriginal: moment(this.props.fechaProceso, 'DD/MM/YYYY')})
            }else{
                var fecha = new Date(value.FechaProceso).toISOString().substring(0,10)
                this.setState({fechaOriginal: moment(formatearFecha(fecha), 'DD/MM/YYYY')})
            }
        }else{
            this.setState({fechaOriginal: null})
        }
    }

    //Consulta DB
    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                console.log("RESPUESTA: ", response)
                resolve(response.data)
            })
            .catch((err)=>{
                reject(err);
            });
        });
    }

    //Action Buttons
    guardarFechaMod(){
        var errors = "";
        var proceder = true;
        var data = {};

        if(this.state.modulos_sel===null){
            proceder = false;
            errors = errors+'- Seleccione un modulo a modificar.\n'
        }else if(this.state.modulos_sel!==null&&(this.state.fechaMod===null && this.state.normalizarFecha===false)){
            proceder = false;
            errors = errors+'- Seleccione fecha a modificar.\n'
        }else if(this.state.modulos_sel!==null && this.state.normalizarFecha===true && this.state.fechaMod!==null){
            proceder = false;
            errors = errors+'- No se puede restablecer la fecha proceso de un modulo con el campo fecha nueva lleno.\n'
        }

        if(proceder === true){

            if(this.state.fechaMod!==null){
                data.fechaMod = formatearFechaMoment_a_String(this.state.fechaMod);
            }

            data.normalizar = this.state.normalizarFecha;
            data.modulo = this.state.modulos_sel.value;

            let config_request = {
                method: 'PATCH',
                url: '/modulosporusuario/'+data.modulo,
                data
            }

            global_axios(config_request)
            .then((response)=> {             
                alert(response.data.msg);
                this.limpiar();
                this.actualizarFechasPorModulo(this.props.usuario)
                
            })
            .catch((error)=>{
                this.actualizarFechasPorModulo(this.props.usuario)                  
                alert(error.response?error.response.data.msg:error.message);                
            });

        }else{
            alert(errors)
        }
    }

    limpiar(){
        this.cargarObjetos('/cierrecartera?empresa='+this.state.empresa).then((resp)=>{
            let fecha = null

            if(resp.CierreCartera!==null){
                fecha = moment(resp.CierreCartera, 'DD/MM/YYYY');
            }

            this.setState({fechaCierre: fecha, normalizarFecha: false})
        })
    }

    //REACT CYCLE
    componentDidMount(){
        let empresa = JSON.parse(getItemDatosSesion('empresaActual')).Id;

        Promise.all([ this.cargarObjetos('/cierrecartera?empresa='+empresa),         
            this.props.generar_LogAuditoriaIngresoForm('1002'), ])
        .then(([ fechacierre ]) => { 
            console.log("FECHA CIERRE", fechacierre) 
            let fecha = fechacierre.CierreCartera!==null?moment(fechacierre.CierreCartera,'DD/MM/YYYY'):null 
            this.setState({fechaCierre: fecha, permiso: this.props.permiso,
            empresa: empresa})       
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('1002');
    }

    guardarFechaCierre(){
        var errors = "";
        var proceder = true;
        var data = {};

        if(this.state.normalizarFecha === false){
            if(this.state.fechaCierre === null){
                proceder = false;
                errors = errors+"- Selecione una fecha antes de continuar\n";
            }else{
                if(moment(formatearFechaMoment_a_String(this.state.fechaCierre),'DD/MM/YYYY').isValid()===false){
                    proceder = false;
                    errors = errors+"- Valores invalidos en la fecha\n";
                }else{
                    
                    let fechaProceso = this.props.fechaProceso
                    let diff = this.state.fechaCierre.diff(moment(fechaProceso, 'DD/MM/YYYY'),'days' )
                    
                    if(diff>0){
                        proceder = false;
                        errors = errors+"- La fecha seleccionada supera la fecha de actual\n";
                    }
                }
                let formatDate = formatearFechaMoment_a_String(this.state.fechaCierre).split("/"); 
                data.Fecha = `01/${formatDate[1]}/${formatDate[2]}`
            }
        }else{
            data.Fecha = null;
        }

        if(proceder === true){
            data.Empresa = this.state.empresa;

            let config_request = {
                method: 'PATCH',
                url: '/cierrecartera?empresa='+data.Empresa,
                data
            }
            global_axios(config_request)
            .then((response)=> {             
                alert(response.data.msg);
                this.limpiar();
            })
            .catch((error)=>{                  
                alert(error.response?error.response.data.msg:error.message);                
            });

        }else{
            alert(errors)
            this.setState({fechaCierre: null})
        }
    }

    render(){
        return(
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Restrición para Ingreso de Cobranza</TituloForm>
            </HeaderForm>
                <CuerpoForm>                    
                    <Row>
                        <ContainerCol className='col-sm-8 col-sm-offset-4 col-sm-pull-4'>
                            <ContainerCol className='col-sm-2' margen_arriba='15' margen_abajo='8'>
                                <LabelForm>Mes a bloquear:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-5' margen_arriba='15' margen_abajo='4'>
                                <PickerFecha fechaSeleccionada={this.state.fechaCierre} func_onChange={(fechaEscogida)=>{this.setState({fechaCierre: fechaEscogida});}} 
                                disabled={this.state.fechaCierre!==null?true:false}/>
                            </ContainerCol>

                            <ContainerCol className='col-sm-4 col-sm-offset-1 col-sm-pull-1' margen_arriba='15' margen_abajo='4'>
                                <LabelForm><input type='checkbox' name='normalizarFecha' checked={this.state.normalizarFecha} 
                                onChange={this.actualizarCampos}/> Desbloquear fecha</LabelForm> 
                            </ContainerCol>
                        </ContainerCol>  
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-primary btn-sm' disabled={this.state.autorizacion===false?true:false} onClick={this.guardarFechaCierre}><i className="fa fa-floppy-o fa-lg" aria-hidden="true"/> Guardar</button>  
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>            
        )   
    }
}

const mapStateToProps = ((state) => {
    return {fechaProceso: state.sesion.valoresSesionForm.FechaProceso,
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
            departamento : state.sesion.valoresSesionForm.Departamento
        }
  });
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, 
                            cambiar_VisualizacionLoading}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormAdmin02);